import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";

import uniqid from "uniqid";
import MessageRow from "./MessageRow";

const MessageList = ({ messages }) => {
  const titles = ["發送時間", "發送對象", "發送內容"];
  return (
    <div>
      <List gridCols="grid-cols-[min-content_1fr_1fr]">
        {titles.map((text) => (
          <TitleCell
            key={uniqid()}
            text={text}
            className="whitespace-nowrap px-2"
          />
        ))}
        {messages.map((message) => (
          <MessageRow key={uniqid()} message={message} />
        ))}
      </List>
    </div>
  );
};

export default MessageList;
